const GLoader = () => {
    return (
        <div className="fixed inset-0 flex items-center justify-center z-[102] bg-black/60 backdrop-blur-sm">
            <div className="flex flex-col items-center gap-[16px]">
                <div className="w-[44px] h-[44px] border-[3px] border-white/10 border-t-[#0086D3] rounded-full animate-spin shadow-[0_0_15px_rgba(0,134,211,0.3)]"></div>
            </div>
        </div>
    )
}

export default GLoader
